import { render } from "./App.vue?vue&type=template&id=85696f0a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=85696f0a&lang=css"

import exportComponent from "/home/hans/projecten/zwart-av/switcher/software/switcher-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__